module.exports = __webpack_public_path__ + "media/explosion1.aa45cd01.ogg";